export const iconStyles = {
  padding: 0,
  position: 'absolute',
  top: 0,
  right: 0,
  cursor: 'default',
};
